type Nullish<T> = T | null | undefined;

/**
 * Tries to convert the value to a number, returns `0` if value is nullish or NaN
 */
export const asNumber = (num: Nullish<string | number>): number => {
  if (typeof num === "number") return num;
  if (num === undefined || num === null) {
    return 0;
  }
  const res = parseFloat(num);
  return Number.isNaN(res) ? 0 : res;
};

/**
 * Tries to convert the given value to number, returns `undefined` if value is nullish,
 * or if the result is Nan.
 */
export const asMaybeNumber = (
  num: Nullish<string | number>
): number | undefined => {
  if (typeof num === "number") return num;
  if (num === undefined || num === null) {
    return undefined;
  }
  const res = parseFloat(num);
  return Number.isNaN(res) ? undefined : res;
};

/* Creates dropdown options */
export const toOption = (value: string) => ({ value, label: value });
